/* Impact ladder. Batch B, 20 Aug 2026.
   Bands mirror routeResultScreen() in sections/glp-bmi-screen.liquid:
   bmi >= 27.5 eligible, >= 25 borderline, else outside range.
   The sub 18.5 guard is deliberate and has no counterpart in the flow.

   RULER INPUT, rewritten 20 Aug 2026 after two reproduced bugs:

   1. RUNAWAY ON HOVER. pointerup set the state flag back to 0 but left sx, sy
      and sv holding the values from the last press. The move handler treated
      state 0 as "a drag might be starting" and never checked whether a button
      was actually held, so the next mostly horizontal mouse move with no button
      down re-armed the drag and the ruler followed the cursor. Reproduced:
      72 kg, dragged to 77, then two hover moves with buttons:0 took it to 85
      and then 94 with nothing pressed.
      Fixed by gating every move on an active pointerId, and by ending the
      gesture if a mouse move arrives with e.buttons === 0.

   2. CLICK DID NOTHING. Only dragging changed the value, so a plain click or a
      tap was ignored. Reproduced: 72 before, 72 after a down/up with no move.
      Fixed with tap to position, below: releasing without meaningful movement
      snaps to whichever tick sits under the pointer.

   Also added: trackpad horizontal swipe. Vertical wheel is deliberately NOT
   captured, so scrolling the page past the widget can never change the value. */
(function(){
  var root = document.getElementById('pwl');
  if(!root) return;
  var TW = 12, lastB = null;
  var q = function(s){ return root.querySelector(s); };
  var outs = function(n){ return root.querySelectorAll('[data-o="'+n+'"]'); };
  var set = function(n,v){ outs(n).forEach(function(e){ e.innerHTML = v; }); };
  var rls = root.querySelectorAll('.pwl-rl');
  var dock = q('.pwl-dock');

  rls.forEach(function(r){
    var min = +r.dataset.min, max = +r.dataset.max, h = '';
    for(var v = min; v <= max; v++){
      var c = 'pwl-t';
      if(v % 10 === 0) c += ' pwl-j'; else if(v % 5 === 0) c += ' pwl-m';
      h += '<span class="'+c+'"></span>';
    }
    r.querySelector('.pwl-tks').innerHTML = h;
  });

  function paint(r){
    var min = +r.dataset.min, v = +r.dataset.val;
    r.querySelector('.pwl-tks').style.transform =
      'translateX(' + (r.querySelector('.pwl-trk').clientWidth/2 - (v-min)*TW) + 'px)';
    r.setAttribute('aria-valuenow', v);
  }
  function val(n){ return +q('.pwl-rl[data-rl="'+n+'"]').dataset.val; }
  function setv(r,v){
    var min = +r.dataset.min, max = +r.dataset.max;
    v = Math.max(min, Math.min(max, Math.round(v)));
    if(+r.dataset.val === v){ paint(r); return; }
    r.dataset.val = v; paint(r); update();
  }

  function update(){
    var W = val('w'), H = val('h');
    set('w', W); set('h', H);
    var bmi = W / Math.pow(H/100, 2), bs = bmi.toFixed(1);
    if(bs !== lastB){
      lastB = bs; set('bmi', bs);
      outs('bmi').forEach(function(e){
        e.classList.add('pwl-bump');
        clearTimeout(e._t);
        e._t = setTimeout(function(){ e.classList.remove('pwl-bump'); }, 320);
      });
    }
    var lo = Math.round(W*0.15), hi = Math.round(W*0.20), under = bmi < 18.5;
    q('[data-lad]').style.display = under ? 'none' : '';
    q('.pwl-bp').style.display = under ? 'none' : '';
    q('.pwl-lh').style.display = under ? 'none' : '';
    q('.pwl-swipe').style.visibility = under ? 'hidden' : '';

    if(under){
      set('pay','&mdash;'); set('dpay','&mdash;');
      set('paysub','Not the right starting point here.');
      set('dsub','Speak to a doctor');
      set('stat','<b>Below the range</b> GLP-1 treatment is considered for.');
      set('ctat','Talk to a doctor');
    } else {
      var kg = lo + ' to ' + hi + '<span class="pwl-u">kg</span>';
      set('pay', kg); set('dpay', kg);
      set('paysub','Around ' + (W-hi) + ' to ' + (W-lo) + ' kg.');
      set('dsub','around ' + (W-hi) + ' to ' + (W-lo) + ' kg &middot; BMI ' + bs);
      if(bmi >= 27.5){ set('stat','<b>Within the range</b> we treat.'); set('ctat','Confirm eligibility'); }
      else if(bmi >= 25){ set('stat','<b>A doctor reviews this one</b> personally.'); set('ctat','Confirm eligibility'); }
      else { set('stat','Usually <b>outside the range</b> we treat with GLP-1.'); set('ctat','Confirm eligibility'); }
      root.querySelectorAll('[data-kg]').forEach(function(e){
        e.textContent = Math.round(W * (+e.dataset.kg) / 100);
      });
      set('bpkg', lo + ' to ' + hi + ' kg');
      set('bpmm', lo + ' to ' + hi + ' mmHg');
    }
  }

  /* Hand the numbers to the eligibility flow. Merges into the flow's own key and
     never writes outcome, so the flow still decides and cannot be skipped. */
  function handoff(){
    try{
      var raw = localStorage.getItem('glp_flow_state');
      var st = raw ? JSON.parse(raw) : {};
      st.height = val('h'); st.weight = val('w');
      st.bmi = Number((val('w') / Math.pow(val('h')/100, 2)).toFixed(1));
      localStorage.setItem('glp_flow_state', JSON.stringify(st));
    }catch(e){}
  }
  outs('cta').forEach(function(a){ a.addEventListener('click', handoff); });

  rls.forEach(function(r){
    /* id === null means no gesture is in progress. Nothing moves the ruler while
       it is null. That single gate is what stops the runaway described above. */
    var id = null, sx = 0, sy = 0, sv = 0, far = 0, mode = 0;
    /* mode 0 undecided, 1 dragging, 2 the user is scrolling the page vertically */

    function reset(){
      if(id !== null){ try{ r.releasePointerCapture(id); }catch(err){} }
      id = null; mode = 0; far = 0;
    }

    r.addEventListener('pointerdown', function(e){
      if(e.pointerType === 'mouse' && e.button !== 0) return;
      id = e.pointerId; sx = e.clientX; sy = e.clientY;
      sv = +r.dataset.val; far = 0;
      /* A mouse press is unambiguous, so start dragging at once. Touch has to
         wait, because the same gesture might be a vertical page scroll. */
      mode = (e.pointerType === 'mouse') ? 1 : 0;
      if(mode === 1){ r.classList.add('pwl-on'); try{ r.setPointerCapture(id); }catch(err){} }
    });

    r.addEventListener('pointermove', function(e){
      if(id === null || e.pointerId !== id) return;
      /* The button was released somewhere we never saw the pointerup. */
      if(e.pointerType === 'mouse' && e.buttons === 0){ reset(); return; }
      if(mode === 2) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if(Math.abs(dx) > far) far = Math.abs(dx);
      if(mode === 0){
        if(Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        if(Math.abs(dy) > Math.abs(dx)){ mode = 2; return; }
        mode = 1; r.classList.add('pwl-on');
        try{ r.setPointerCapture(id); }catch(err){}
      }
      e.preventDefault();
      setv(r, sv - dx/TW);
    });

    function finish(e){
      if(id === null) return;
      if(e && e.pointerId !== id) return;
      /* Tap or click to position. Released without meaningful travel, so treat it
         as "put the needle on the tick I am pointing at" rather than ignoring it.
         The track is centred on the needle, so the offset from centre in pixels
         divided by the tick pitch is the change in value. */
      if(e && mode !== 2 && far < 5 && typeof e.clientX === 'number'){
        var b = r.querySelector('.pwl-trk').getBoundingClientRect();
        r.classList.add('pwl-on');
        setv(r, sv + (e.clientX - (b.left + b.width/2))/TW);
      }
      reset();
    }
    r.addEventListener('pointerup', finish);
    r.addEventListener('pointercancel', finish);
    r.addEventListener('lostpointercapture', function(){ id = null; mode = 0; far = 0; });
    r.addEventListener('dragstart', function(e){ e.preventDefault(); });

    /* Trackpad swipe. Horizontal intent only: if the gesture is mostly vertical
       it is page scrolling and must be left alone, otherwise scrolling past the
       widget would silently change the visitor's weight. */
    r.addEventListener('wheel', function(e){
      if(Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      r.classList.add('pwl-on');
      setv(r, +r.dataset.val + (e.deltaX > 0 ? 1 : -1));
    }, {passive:false});

    r.addEventListener('keydown', function(e){
      var s = e.shiftKey ? 10 : 1, v = +r.dataset.val, n = null;
      if(e.key === 'ArrowRight' || e.key === 'ArrowUp') n = v + s;
      else if(e.key === 'ArrowLeft' || e.key === 'ArrowDown') n = v - s;
      if(n === null) return;
      e.preventDefault(); r.classList.add('pwl-on'); setv(r, n);
    });
  });

  window.addEventListener('resize', function(){ rls.forEach(paint); });
  rls.forEach(paint);
  update();

  if('IntersectionObserver' in window){
    var seen = false;
    new IntersectionObserver(function(en){
      en.forEach(function(x){
        /* the dock and the floating pill both live at the bottom edge */
        var dockUp = x.isIntersecting && dock && getComputedStyle(dock).display !== 'none';
        document.body.classList.toggle('pwl-dock-on', dockUp);
        if(!x.isIntersecting || seen) return;
        seen = true;
        root.querySelectorAll('.pwl-rung').forEach(function(r,i){
          setTimeout(function(){ r.classList.add('pwl-in'); }, 150*i);
        });
        rls.forEach(function(r,i){
          setTimeout(function(){
            if(r.classList.contains('pwl-on')) return;
            r.classList.add('pwl-nudge');
            setTimeout(function(){ r.classList.remove('pwl-nudge'); }, 1600);
          }, 400 + i*360);
        });
      });
    }, {threshold:0.2}).observe(root);
  } else {
    root.querySelectorAll('.pwl-rung').forEach(function(r){ r.classList.add('pwl-in'); });
  }
})();
